<template>
  <highcharts class="fit-highchart" ref="highchart" :options="options" />
</template>

<script>
import { cloneDeep, forEach } from 'lodash';
import { scatterOptions } from '@/constants/chart-options';
import { convertValuByUnit } from '@/utils/number';

export default {
  name: 'WMajorProcessScatterChart',
  data() {
    return {
      options: cloneDeep(scatterOptions),
    };
  },
  methods: {
    setData(value) {
      this.options.series = [];
      this.options.legend = false;
      this.options.xAxis = {
        title: false,
        startOnTick: false,
        endOnTick: true,
        showLastLabel: true,
        tickInterval: 5,
        max: 100,
        labels: {
          format: '{value}%',
        },
      };
      this.options.yAxis = {
        startOnTick: false,
        title: false,
        labels: {
          formatter() {
            return convertValuByUnit(this.value, 'KB', true, true);
          },
        },
      };

      forEach(value, (data) => {
        this.options.series.push({
          name: `${data.objName} [${data.processId}]`,
          data: [data.data],
        });
      });
      this.options.plotOptions = {
        series: {
          animation: false,
          marker: {
            radius: 5,
          },
        },
      };
      this.options.tooltip = {
        formatter() {
          const mem = convertValuByUnit(this.y, 'KB', true, true);
          return `<b>${this.series.name}</b><br>CPU 사용률: ${this.x}%<br>메모리 사용량: ${mem}`;
        },
        // pointFormat: 'CPU 사용률: {point.x}%<br>메모리 사용량: {point.y}kb',
      };
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/performance/node/operation/service/chart/MajorProcessScatterChart.vue